const sensitiveKey = /authorization|cookie|password|secret|token/i;
export const redactAttributes = (attributes = {}) => Object.fromEntries(Object.entries(attributes).map(([key, value]) => [
    key,
    sensitiveKey.test(key) ? "[REDACTED]" : value,
]));
export const noOpTelemetry = {
    event: () => undefined,
    error: () => undefined,
    span: (_name, operation) => operation(),
};
//# sourceMappingURL=index.js.map